import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const routes = [
    {
        path: "/kline",
        name: "kline",
        component: () => import("../views/market/kline"),
        meta: { keepAlive: false },
    },
    {
        path: "/pcview",
        component: () => import("../views/home/pcview"),
        meta: { keepAlive: false },
    },
    {
        path: "/invite",
        component: () => import("../views/user/invite"),
    },
    {
        path: "/about",
        component: () => import("../views/user/about"),
        meta: { keepAlive: true },
    },
    {
        path: "/notice",
        component: () => import("../views/user/notice"),
        meta: { keepAlive: true },
    },
    {
        path: "/sitedigital",
        component: () => import("../views/user/sitedigital"),
        meta: { keepAlive: true },
    },
    {
        path: "/mymsg",
        component: () => import("../views/user/mymsg"),
        meta: { keepAlive: true },
    },
    {
        path: "/personal",
        component: () => import("../views/user/personal"),
        meta: { keepAlive: true },
    },
    {
        path: "/updateuser/:fieldKey",
        component: () => import("../views/user/updateuser"),
        meta: { keepAlive: true },
    },
    {
        path: "/updatepassword/:fieldKey",
        component: () => import("../views/user/updatepassword"),
        meta: { keepAlive: true },
    },
    {
        path: "/avater",
        component: () => import("../views/user/avater"),
        meta: { keepAlive: true },
    },
    {
        path: "/wallet",
        component: () => import("../views/user/wallet"),
        meta: { keepAlive: true },
    },
    {
        path: "/bankwallet",
        component: () => import("../views/user/bankwallet"),
        meta: { keepAlive: true },
    },
    {
        path: "/digitalwallet",
        component: () => import("../views/user/digitalwallet"),
        meta: { keepAlive: true },
    },
    {
        path: "/security",
        component: () => import("../views/user/security"),
        meta: { keepAlive: true },
    },
    {
        path: "/recharge",
        component: () => import("../views/user/recharge"),
        meta: { keepAlive: true },
    },
    {
        path: "/withdraw",
        component: () => import("../views/user/withdraw"),
        meta: { keepAlive: true },
    },
    {
        path: "/mine",
        name: "mine",
        component: () => import("../views/user/mine"),
        meta: { keepAlive: true },
    },
    {
        path: "/chat",
        name: "chat",
        component: () => import("../views/chat/chat"),
        meta: { keepAlive: true },
    },
    {
        path: "/red",
        name: 'red',
        component: () => import("../views/game/red"),
        meta: { keepAlive: true }
    },
    {
        path: "/turn",
        name: 'turn',
        component: () => import("../views/game/turn"),
        meta: { keepAlive: true }
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/user/login"),
        meta: { keepAlive: true }
    },
    {
        path: "/register",
        name: "register",
        component: () => import("../views/user/register"),
        meta: { keepAlive: true }
    },
    {
        path: "/asset",
        name: "asset",
        component: () => import("../views/asset/asset"),
        meta: { keepAlive: true }
    },
    {
        path: "/market",
        name: "market",
        component: () => import("../views/market/index"),
        meta: { keepAlive: false }
    },
    {
        path: "/order",
        name: "order",
        component: () => import("../views/order/order"),
        meta: { keepAlive: true }
    },
    {
        path: "/home",
        name: 'home',
        component: () => import("../views/home/home"),
        meta: { keepAlive: false }
    },
    {
        path: "**",
        redirect: "/home"
    }
];
export default new Router({
    mode: "hash",
    base: process.env.BASE_URL,
    routes
});

Vue.use(Router)
// 解决报错
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
// push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err);
}
// replace
Router.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => err);
}
